import { Controller } from "@hotwired/stimulus"

// Reloads the page after a successful Turbo form submission.
// Usage: data-controller="form-reload" data-action="turbo:submit-end->form-reload#reload"
export default class extends Controller {
  reload(event) {
    if (event.detail.success) {
      window.Turbo.visit(window.location.href)
    }
  }
}
